import {Linking, Platform} from 'react-native';
import SendIntentAndroid from 'react-native-send-intent';
import {openExternalLink} from '../pipes';

export type ExternalAppName = 'Frisbi' | 'Ekarta';
export type AllowedPlatform = Exclude<typeof Platform.OS, 'macos' | 'windows'>;

type ExternalAppController = {
  [key in ExternalAppName]: {
    [k in AllowedPlatform]: {
      storeLink?: string;
      packageUrl?: string;
      openLink?: () => void;
    };
  };
};

export const ExternalAppController: ExternalAppController = {
  Ekarta: {
    android: {
      packageUrl: 'net.payiq.ekarta',
      storeLink: 'https://play.google.com/store/apps/details?id=net.payiq.ekarta',
      async openLink() {
        if (await SendIntentAndroid.isAppInstalled(this.packageUrl!))
          await SendIntentAndroid.openApp(this.packageUrl!, {});
        else await openExternalLink(this.storeLink!);
      },
    },
    ios: {
      packageUrl: 'https://apps.apple.com/us/app/ekarta/id1569780685?l=ru-RU',
      storeLink: 'https://apps.apple.com/us/app/ekarta/id1569780685?l=ru-RU',
      async openLink() {
        if (await Linking.canOpenURL(this.packageUrl!)) await Linking.openURL(this.packageUrl!);
        else if (await Linking.canOpenURL(this.storeLink!)) {
          await Linking.openURL(this.storeLink!);
        }
      },
    },
    web: {
      async openLink() {
        if (await Linking.canOpenURL(this.storeLink!)) {
          await Linking.openURL(this.storeLink!);
        }
      },
      storeLink: 'https://www.ekarta-ek.ru/obshchie-razdely/oplata/',
    },
  },

  Frisbi: {
    android: {
      packageUrl: 'ru.frisbi24',
      storeLink: 'https://play.google.com/store/apps/details?id=ru.frisbi24',
      async openLink() {
        if (await SendIntentAndroid.isAppInstalled(this.packageUrl!))
          await SendIntentAndroid.openApp(this.packageUrl!, {});
        else await openExternalLink(this.storeLink!);
      },
    },
    ios: {
      packageUrl: 'frisbi24://frisbi24.ru/services/transport_cards/5178/add',
      storeLink: 'https://apps.apple.com/ru/app/фрисби24/id1377962968?l=ru-RU',
      async openLink() {
        if (await Linking.canOpenURL(this.packageUrl!)) await Linking.openURL(this.packageUrl!);
        else if (await Linking.canOpenURL(this.storeLink!)) {
          await Linking.openURL(this.storeLink!);
        }
      },
    },
    web: {
      async openLink() {
        if (await Linking.canOpenURL(this.storeLink!)) {
          await Linking.openURL(this.storeLink!);
        }
      },
      storeLink: 'https://frisbi24.ru/services/pay/5178-udobnyy-marshrut',
    },
  },
};
